import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {TokenService} from '../services/token.service';
import {RouterService} from '../services/router.service';
import {ResetPasswordEnforcementService} from '../services/reset-password-enforcement.service';

export const authLoginRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const tokenService = inject(TokenService);
  const routerService = inject(RouterService);
  const resetPasswordEnforcementService = inject(ResetPasswordEnforcementService);

  if (!tokenService.hasToken()) {
    return true;
  }

  if (resetPasswordEnforcementService.hasPasswordChangeRequirement()) {
    return router.parseUrl('/auth/password/change');
  }

  routerService.navigateToStart();
  return false;
};
